import { render } from "./InformasiHrd.vue?vue&type=template&id=4177062f&scoped=true"
import script from "./InformasiHrd.vue?vue&type=script&lang=js"
export * from "./InformasiHrd.vue?vue&type=script&lang=js"

import "./InformasiHrd.vue?vue&type=style&index=0&id=4177062f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4177062f"]])

export default __exports__